import './index.scss'
import '../../assets/styles/language.css'
import '../../assets/scripts/trp-frontend-language-switcher.js'
import '../../assets/scripts/trp-language-cookie.js'
$("header .nav li").hover(function(){
    $("header .nav li dl").stop().slideUp()
    $(this).find("dl").stop().slideDown()
}
,function(){
    $(this).find("dl").hide()
})
// $(".header-bg").mouseleave(function(){
//     $(".header-bg").stop().slideUp()
//     $("header .nav li .navchild").stop().slideUp()
// })

$("header .nav li").eq(0).hover(function(){
    $(".header-bg").stop().slideUp()
})

$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})

//滚动定位
$(document).ready(function() {
    if (location.hash) {
        setTimeout(function() {
            var targetOffset = $(location.hash).offset().top;
        console.log(targetOffset)
            $('html, body').animate({
                scrollTop: targetOffset - 98
            }, 500);
        }, 10);
    }
});


$(".navchild dl dd").eq(0).addClass("active");
$(".navchild .content .text").eq(0).addClass("active");
$(".navchild .right .animals").eq(0).addClass("active");

$(".navchild dl dd").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".navchild .content .text").eq(index).addClass("active").siblings().removeClass("active");
    $(".navchild .right .animals").eq(index).addClass("active").siblings().removeClass("active");
})
$("header .head .nav ul li").hover(function() {
    $(".navchild").removeClass("active");
    $(".header-model").hide();
})

$("header .head .nav ul li").eq(1).hover(function() {
    $(".navchild").addClass("active");
    $(".header-model").show();
})
$(".navchild").mouseleave(function() {
    $(".navchild").removeClass("active");
    $(".header-model").hide();
})
